import React, { useState } from 'react';
import { lnAssets } from '../utils/lnAssets';
import { SITE_PRACTITIONER_CREDENTIALS, SITE_PRACTITIONER_NAME } from '../sitePlaceholders';
import '../styles/LisaPortrait.css';

type LisaPortraitProps = {
  className?: string;
  /** Hide caption below the frame (e.g. contact sidebar) */
  showCaption?: boolean;
};

/**
 * Dedicated portrait frame for Lisa — loads `public/lisa/lisa-portrait.png`.
 */
const LisaPortrait: React.FC<LisaPortraitProps> = ({ className = '', showCaption = true }) => {
  const [useFallback, setUseFallback] = useState(false);
  const portraitSrc = lnAssets.photos.lisaPortrait;

  return (
    <figure className={`i3-lisa-portrait ${className}`.trim()}>
      <div className="i3-lisa-portrait-frame">
        {!useFallback ? (
          <img
            src={portraitSrc}
            alt={SITE_PRACTITIONER_CREDENTIALS}
            className="i3-lisa-portrait-img"
            loading="lazy"
            decoding="async"
            onError={() => setUseFallback(true)}
          />
        ) : (
          <div className="i3-lisa-portrait-fallback" role="img" aria-label={`Portrait of ${SITE_PRACTITIONER_NAME} — photo coming soon`}>
            <span className="i3-lisa-portrait-fallback-icon" aria-hidden>
              LN
            </span>
            <span className="i3-lisa-portrait-fallback-note">Portrait photo coming soon</span>
          </div>
        )}
      </div>
      {showCaption ? (
        <figcaption className="i3-lisa-portrait-caption">{SITE_PRACTITIONER_CREDENTIALS}</figcaption>
      ) : null}
    </figure>
  );
};

export default LisaPortrait;
